import { Embed } from '@tribeplatform/gql-client/types'

import { MessageEmbedRenderer } from './MessageEmbedRenderer.js'

interface Props {
  embeds?: Embed[]
}

export const MessageEmbeds = ({ embeds }: Props) => {
  if (!embeds?.length) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      {embeds.map(embed => (
        <div
          className="max-w-full sm:max-w-[22rem] w-[22rem] max-h-[15rem]"
          key={embed.id}
        >
          <MessageEmbedRenderer embed={embed} />
        </div>
      ))}
    </div>
  )
}
